import { useIntl } from 'react-intl';
import { PaymentType } from 'common/constants';
import { useFlagValue } from 'hooks/useFlags';
import { messages } from '../../pages/VendorsTablePage/messages';
import type { PageHeaderDropdownOption } from './types';

export const usePaymentTypeOptions = (): PageHeaderDropdownOption[] => {
  const intl = useIntl();
  const odcFlag = useFlagValue('dmsAccountingOnDemandPayments');
  return [
    {
      id: PaymentType.AccountsPayable,
      label: intl.formatMessage(messages.accountsPayable)
    },
    ...(odcFlag
      ? [
          {
            id: PaymentType.OnDemand,
            label: intl.formatMessage(messages.onDemand)
          }
        ]
      : []),
    {
      id: PaymentType.Register,
      label: intl.formatMessage(messages.paymentRegister)
    }
  ];
};
